import { useLocale } from '@lessonup/client-integration';
import { BodyText, Card, Introduction, SpaceBetween, spacing, styled, useTranslation } from '@lessonup/ui-components';
import { dateToShortLocale } from '@lessonup/utils';
import React from 'react';
import { i18nextNamespace } from '../../utils/consts';
import { Report, ReportLesson } from '../../utils/types';

export interface SummaryCardProps {
  report: Pick<Report, 'taughtAt' | 'numberOfStudents'> & { lesson: Pick<ReportLesson, 'name'> };
}

export const SummaryCard: React.FC<SummaryCardProps> = ({ report }) => {
  const locale = useLocale();
  const { t } = useTranslation(i18nextNamespace, { keyPrefix: 'summaryCard' });

  return (
    <StyledCard showBorder={false}>
      <SpaceBetween direction="y" spacing={spacing.size16}>
        <Introduction
          alignment="start"
          size="M"
          headline={report.lesson.name}
          bodyText={<BodyText>{dateToShortLocale(report.taughtAt, locale)}</BodyText>}
        />
        <Introduction
          alignment="start"
          size="S"
          headline={t('studentsTitle', { count: report.numberOfStudents })}
          bodyText={t('studentsDescription', { count: report.numberOfStudents })}
        />
      </SpaceBetween>
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  padding: ${spacing.size16};
  width: 100%;
`;
